/* eslint-disable import/prefer-default-export */
import { useQuery } from "@tanstack/react-query";
import { getRateCardTemplates } from "api/services/rateCard";
import { rateCardQueryKeys } from "./rateCardQueryKeys";

export const useGetRateCardTemplates = (enabled = true) =>
  useQuery({
    queryKey: rateCardQueryKeys.rateCardTemplates(),
    queryFn: ({ signal }) => getRateCardTemplates({ signal }).then((res) => res.data),
    enabled,
  });
